import { Component, OnInit, Input } from '@angular/core';
import { AdditionalGuaranties } from '@app/core/business/product/additional-guaranty';
import { environment } from '@env/environment';

@Component({
  selector: 'app-additional-guaranties',
  templateUrl: './additional-guaranties.component.html',
  styleUrls: ['./additional-guaranties.component.scss'],
})
export class AdditionalGuarantiesComponent implements OnInit {
  @Input()
  additionalGuaranty: AdditionalGuaranties;

  public env = environment;

  constructor() {}

  ngOnInit() {}
}
